/**
 * Petmall comparison table — re-render on variant change.
 *
 * The table is built server-side for `product.selected_or_first_available_variant` (pack size
 * = the selected variant), so when the shopper picks another variant it is fetched again via
 * the Section Rendering API (`?variant=<id>&section_id=<id>`) and swapped in place. The whole
 * section (including "no comparison for this pack") is replaced, so it appears/disappears
 * correctly too.
 */
(function () {
  function init(root) {
    var sectionId = root.dataset.sectionId;
    var productUrl = root.dataset.productUrl;
    if (!sectionId || !productUrl) return;
    var ctrl = null;
    var lastVariant = root.dataset.variantId || '';

    function refresh(variant) {
      if (!variant || !variant.id || String(variant.id) === lastVariant) return;
      lastVariant = String(variant.id);
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      url.searchParams.set('section_id', sectionId);
      fetch(url.toString(), { signal: ctrl.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-compare-refresh]');
          var host = document.getElementById('shopify-section-' + sectionId);
          if (!host) return;
          if (fresh) {
            var current = host.querySelector('[data-compare-refresh]');
            if (current) current.replaceWith(fresh);
            else host.appendChild(fresh);
            fresh.dataset.variantId = lastVariant;
            init(fresh);
          } else {
            // No comparison for this pack size — leave an empty (invisible) section.
            var stale = host.querySelector('[data-compare-refresh]');
            if (stale) stale.innerHTML = '';
          }
        })
        .catch(function (e) { if (e && e.name !== 'AbortError') console.warn('[compare] refresh failed', e); });
    }

    if (root._compareBound) return;
    root._compareBound = true;
    document.addEventListener('variant:changed', function (e) { refresh(e.detail && e.detail.variant); });
  }

  document.querySelectorAll('[data-compare-refresh]').forEach(init);
})();
